import { throwError } from "../../../utils/helper";

type Item = {
  image_attachment_id: string;
  title: string;
  subtitle: string;

  video_attachment_id: string;
  is_expandable: boolean;
  cta_text: string;
  video_attachment_type?: string;
};
type HeaderTags = {
  text: string;
  color: string;
};
class HeroVideo {
  /* sole purpose of variables declared below are 
  documentation reference purpose only */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  header!: string;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  header_tags!: HeaderTags[];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  items: Item[] = [];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  show_item_details!: boolean;

  getSerializedData = (widgetFormData: HeroVideo) => {
    let itemModified = widgetFormData?.items?.map((item: Item) => {
      delete item.video_attachment_type;
      return {
        ...item,
        is_expandable: Boolean(item.is_expandable),
      };
    });
    widgetFormData.items = itemModified;
    return widgetFormData;
  };
  getDeSerializedData = (widgetFormData: HeroVideo) => {
    return widgetFormData;
  };

  headerValidator = async (rule: any, value: any) => {
    if (!value) return Promise.resolve();
  };
  headerTagsTextValidator = async (rule: any, value: any) => {
    if (!value) throwError("Header tags text required!");
  };
  headerTagsColorValidator = async (rule: any, value: any) => {
    if (!value) throwError("Header tags color required!");
  };
  imageAttachmentValidator = async (rule: any, value: any) => {
    if (!value) throwError("Image Attachment required!");
  };
  titleValidator = async (rule: any, value: any) => {
    if (!value) throwError("Title required!");
  };
  subtitleValidator = async (rule: any, value: any) => {
    if (!value) throwError("Subtitle required!");
  };
  videoAttachmentTypeValidator = async (rule: any, value: any) => {
    if (!value) throwError("Video Attachment Type required!");
  };
  videoRefCodeValidator = async (rule: any, value: any) => {
    if (!value) throwError("Video ref Code required!");
  };
  ctaTextValidator = async (rule: any, value: any) => {
    if (!value) throwError("CTA Text required!");
  };
}
export default HeroVideo;
export const HeroVideoInstance = new HeroVideo();
